import { render, staticRenderFns } from "./CardHeading.vue?vue&type=template&id=2b21f876"
import script from "./CardHeading.vue?vue&type=script&lang=js"
export * from "./CardHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports